<template>
  <Container>
    <GoogleEmmRegistrationInfo
      @delete-registration-click="handleDeleteRegistration"
    />
    <GoogleEmmDeleteRegistration
      v-if="deleteRegistration"
      @cancel-delete-registration-confirmation="handleCancelRegistration"
    />
    <Grid>
      <GridItem :gridSpan="6">
        <GoogleEmmUserConfig />
      </GridItem>
      <GridItem :gridSpan="6">
        <GoogleEmmAdminConfig />
      </GridItem>
    </Grid>
  </Container>
</template>

<script>
import {
  Container,
  Grid,
  GridItem,
} from '@jumpcloud/ui-components';
import GoogleEmmAdminConfig from 'client/MDM/GoogleEmmAdminConfig';
import GoogleEmmDeleteRegistration from 'client/MDM/GoogleEmmDeleteRegistration';
import GoogleEmmRegistrationInfo from 'client/MDM/GoogleEmmRegistrationInfo';
import GoogleEmmUserConfig from 'client/MDM/GoogleEmmUserConfig';

export default {
  name: 'GoogleEmmRegistration',

  components: {
    Container,
    GoogleEmmAdminConfig,
    GoogleEmmDeleteRegistration,
    GoogleEmmRegistrationInfo,
    GoogleEmmUserConfig,
    Grid,
    GridItem,
  },

  data: () => ({
    deleteRegistration: false,
  }),

  methods: {
    handleCancelRegistration() {
      this.deleteRegistration = false;
    },

    handleDeleteRegistration() {
      this.deleteRegistration = true;
    },
  },
};
</script>
